export const isNegativeNumber = (value) => {
  if (typeof value === 'string') {
    return value.startsWith('-');
  }

  return value < 0;
}